var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FF0000",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0757 10.6038L15.0757 10.6038L15.077 10.601C15.1688 10.4032 15.3451 10.2998 15.5172 10.2998H19.2797C19.4517 10.2998 19.6281 10.4032 19.7198 10.601L19.7198 10.601L19.7212 10.6038L19.9462 11.0812L20.0814 11.368H20.3984H23.3984C23.6449 11.368 23.8984 11.5899 23.8984 11.9362C23.8984 12.2824 23.6449 12.5044 23.3984 12.5044H11.3984C11.152 12.5044 10.8984 12.2824 10.8984 11.9362C10.8984 11.5899 11.152 11.368 11.3984 11.368H14.3984H14.7155L14.8507 11.0812L15.0757 10.6038ZM12.5601 25.359L11.9286 14.5725H22.8683L22.2368 25.359C22.2007 25.9683 21.737 26.3907 21.2391 26.3907H13.5578C13.0599 26.3907 12.5962 25.9683 12.5601 25.3592C12.5601 25.3591 12.5601 25.3591 12.5601 25.359Z",
    fill: "#FF3838",
    stroke: "#FF3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8696 18.8238C17.8696 18.6576 17.7372 18.5234 17.5734 18.5234C17.4096 18.5234 17.2773 18.6576 17.2773 18.8238V20.1752H15.9446C15.7808 20.1752 15.6484 20.3095 15.6484 20.4756C15.6484 20.6417 15.7808 20.7759 15.9446 20.7759H17.2773V22.1274C17.2773 22.2935 17.4096 22.4277 17.5734 22.4277C17.7372 22.4277 17.8696 22.2935 17.8696 22.1274V20.7759H19.2023C19.3661 20.7759 19.4984 20.6417 19.4984 20.4756C19.4984 20.3095 19.3661 20.1752 19.2023 20.1752H17.8696V18.8238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.a8e950bf70778261b5c1078ff8d2cc3e.svg";
export { ForwardRef as ReactComponent };